import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ROUTER_OUTLET_NAME } from "@modules/+new/shared/universal-modal/entities/magic";

@Injectable({
	providedIn: "root"
})
export class IframeV4EntryHelperService {
	private router = inject(Router);

	openModal(name: string): void {
		this.router.navigate([{ outlets: { [ROUTER_OUTLET_NAME]: ["v4", name] } }]);
	}
}
